import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {ConfirmationDialog} from 'shells/confirmation-dialog/confirmation-dialog';
import {WhatsAppIcon} from 'shells/icon/svg/whatsapp-icon';
import {IntegrationWidget} from 'shells/integration-widget/integration-widget';
import type {IntegrationWidgetStatus} from 'shells/integration-widget/integration-widget';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';

import type {GetWhatsAppIntegration_whatsAppIntegration as WhatsAppIntegration} from 'nutshell-graphql-types';

import {getIntegrationWidgetStatusEnum} from '../../inbound/helpers';

import {useToggleWhatsAppIsEnabled} from '../graphql/hooks';

import {SettingsWrapper} from './settings-wrapper';
import {SyncStatusBanner} from './sync-status/sync-status-banner';

type Props = {
    whatsAppIntegration: WhatsAppIntegration;
};

export function SettingsIntegrationComplete(props: Props) {
    const [integrationWidgetStatus, setIntegrationWidgetStatus] =
        React.useState<IntegrationWidgetStatus>(
            getIntegrationWidgetStatusEnum(props.whatsAppIntegration.isEnabled, false)
        );
    const [isConfirmationDialogOpen, setIsConfirmationDialogOpen] = React.useState<boolean>(false);

    const {toggleWhatsAppIsEnabled} = useToggleWhatsAppIsEnabled();

    React.useEffect(() => {
        setIntegrationWidgetStatus(
            getIntegrationWidgetStatusEnum(props.whatsAppIntegration.isEnabled, false)
        );
    }, [props.whatsAppIntegration]);

    const onToggleClick = () => {
        toggleWhatsAppIsEnabled(props.whatsAppIntegration.isEnabled);
    };

    const isOnBusinessApp = props.whatsAppIntegration.isOnBusinessApp;

    return (
        <>
            <StackLegacy spacing={16}>
                <SyncStatusBanner whatsAppIntegration={props.whatsAppIntegration} />
                <IntegrationWidget
                    account={props.whatsAppIntegration.userPhoneNumber}
                    logo={
                        <WhatsAppIcon
                            size={24}
                            alignCenter={true}
                            wrapWithDiv={false}
                            // @ts-expect-error
                            color={colors.whatsappGreen}
                        />
                    }
                    status={integrationWidgetStatus}
                    onConnectClick={onToggleClick}
                    onDisconnectClick={onToggleClick}
                    onRevokeClick={() => setIsConfirmationDialogOpen(true)}
                />
                <SettingsWrapper />
            </StackLegacy>
            {isConfirmationDialogOpen && (
                <ConfirmationDialog
                    onCancel={() => setIsConfirmationDialogOpen(false)}
                    title='Disconnect via Whatsapp Business'
                    message={
                        isOnBusinessApp
                            ? 'We’ve paused your WhatsApp sync, but per WhatsApp restrictions you must disconnect WhatsApp from Nutshell via the WhatsApp Business mobile app. Once you’ve done that, your connection will disappear.'
                            : 'Are you sure you want to forget this account? You will need to re-connect your WhatsApp Business Account to continue using WhatsApp in Nutshell.'
                    }
                    cancelText='Got it'
                />
            )}
        </>
    );
}
